import React, { useState, useEffect } from 'react';
import { TextField, MenuItem, OutlinedInput, ListItemText, Button, Box, Card, CardContent, Stack, FormControl, InputLabel, Checkbox, FormControlLabel, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';
import { BASE_URL } from '../../App';
import Swal from 'sweetalert2';
import Grid from '@mui/material/Grid';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import * as XLSX from 'xlsx';

const Accounted_Src_Report = () => {
    const currentYear = new Date().getFullYear();
    const [month, setMonth] = useState('');
    const [year, setYear] = useState(currentYear);
    const [branch, setBranch] = useState('');
    const [psg, setPsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [allBranches, setAllBranches] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [psgOptions, setPsgOptions] = useState([]);
    const login_id = localStorage.getItem("LOGIN_ID");
    const branch_code = localStorage.getItem("BRANCH_CODE")

    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const years = Array.from({ length: 5 }, (_, index) => currentYear - index);

    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const response = await axios.post(BASE_URL + '/GetBranchList', {
                    loginId: login_id,
                    branch_code: branch_code,
                });
                if (response.data && response.data.data) {
                    const branchList = response.data.data.map((branch) => ({
                        BRANCH_CODE: branch.BRANCH_CODE,
                        BRANCH_NAME: branch.BRANCH_NAME,
                    }));
                    setAllBranches(branchList);
                }
            } catch (err) {
                setError('Failed to fetch branches.');
                console.error(err);
            }
        };

        const fetchPsgOptions = async () => {
            try {
                const response = await axios.post(BASE_URL + '/PsgOptions');
                if (response.data && response.data.psglist) {
                    setPsgOptions(response.data.psglist);
                }
            } catch (err) {
                setError('Failed to fetch PSG options.');
                console.error(err);
            }
        };

        fetchBranches();
        fetchPsgOptions();
    }, []);

    const handleSelectAllBranches = () => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            setSelectedBranches(allBranches.map((branch) => branch.BRANCH_CODE));
        } else {
            setSelectedBranches([]);
        }
    };

    const monthMapping = {
        JAN: 1,
        FEB: 2,
        MAR: 3,
        APR: 4,
        MAY: 5,
        JUN: 6,
        JUL: 7,
        AUG: 8,
        SEP: 9,
        OCT: 10,
        NOV: 11,
        DEC: 12,
    };

    const handleViewData = () => {
        const selectedMonthNumber = monthMapping[month];
        if (selectedMonthNumber === undefined) {
            setError('Invalid month abbreviation.');
            return;
        }

        setLoading(true);
        setError(null);
        setShowTable(true);

        Swal.fire({
            title: 'Loading...',
            text: 'Fetching data...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        axios
            .post(BASE_URL + '/Getgriddata', {
                loginId: login_id,
                branch_code: selectedBranches.join(','),
                selectedMonth: month,
                selectedYear: year,
                psgFilter: psg,
            })
            .then((response) => {
                setLoading(false);
                Swal.close();
                if (response.data && response.data.data) {
                    setTableData(response.data.data);
                }
            })
            .catch((err) => {
                setLoading(false);
                Swal.close();
                setError('Failed to fetch grid data.');
                console.error(err);
            });
    };

    const handleDownloadExcel = () => {
        if (tableData.length === 0) {
            Swal.fire({
                title: 'No Data Available',
                text: 'There is no data to download.',
                icon: 'warning',
                confirmButtonText: 'OK',
            });
            return;
        }
    
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to download the Excel file?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, download it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                
                const ws = XLSX.utils.json_to_sheet(tableData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Report');
    
                
                XLSX.writeFile(wb, 'Accounted_Src_Report.xlsx');
    
                Swal.fire({
                    title: 'Download Successful',
                    text: 'The report has been downloaded successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                });
            } else {
                Swal.fire({
                    title: 'Cancelled',
                    text: 'The download has been cancelled.',
                    icon: 'info',
                    confirmButtonText: 'OK',
                });
            }
        });
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f4f4f4', paddingTop: 3 }}>
     <Card sx={{ maxWidth: '100%', width: '100%', margin: 0 }}>
    <CardContent>
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={2}>
           
                <Grid item xs={13} sm={3}>
                    <FormControl sx={{ m: 1, width: '100%' }}>
                        <InputLabel id="branch-label">Select Branches</InputLabel>
                        <Select
                            labelId="branch-label"
                            id="branch-selection"
                            multiple
                            value={selectedBranches}
                            onChange={(e) => setSelectedBranches(e.target.value)}
                            input={<OutlinedInput label="Select Branches" />}
                            renderValue={(selected) => {
                                const selectedBranchNames = selected
                                    .map((branchCode) => {
                                        const branch = allBranches.find((b) => b.BRANCH_CODE === branchCode);
                                        return branch ? branch.BRANCH_NAME : null;
                                    })
                                    .filter(Boolean);
                                return selectedBranchNames.slice(0, 4).join(', ');
                            }}
                        >
                            {allBranches.map((branch) => (
                                <MenuItem key={branch.BRANCH_CODE} value={branch.BRANCH_CODE}>
                                    <Checkbox
                                        checked={selectedBranches.includes(branch.BRANCH_CODE)}
                                        icon={<CheckBoxOutlineBlankIcon />}
                                        checkedIcon={<CheckBoxIcon />}
                                    />
                                    <ListItemText primary={branch.BRANCH_NAME} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={2} sm={1}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={selectAll}
                                onChange={handleSelectAllBranches}
                                icon={<CheckBoxOutlineBlankIcon />}
                                checkedIcon={<CheckBoxIcon />}
                            />
                        }
                        label="Select All"
                    />
                </Grid>

                <Grid item xs={10} sm={2}>
                    <TextField
                        fullWidth
                        select
                        label="Select PSG"
                        value={psg}
                        sx={{ width: '70%' }}
                        onChange={(e) => setPsg(e.target.value)}
                    >
                        {psgOptions.map((psgOption) => (
                            <MenuItem key={psgOption.MATSUBGROUP_CODE} value={psgOption.MATSUBGROUP_CODE}>
                                {psgOption.MATSUBGROUP_CODE}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={2}>
                    <TextField
                        fullWidth
                        select
                        label="Select Month"
                        value={month}
                        sx={{ width: '65%' }}
                        onChange={(e) => setMonth(e.target.value)}
                    >
                        {months.map((month, index) => (
                            <MenuItem key={index} value={month}>
                                {month}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

              
                <Grid item xs={12} sm={3}>
                    <TextField
                        fullWidth
                        select
                        label="Select Year"
                        value={year}
                        sx={{ width: '60%' }}
                        onChange={(e) => setYear(e.target.value)}
                    >
                        {years.map((year) => (
                            <MenuItem key={year} value={year}>
                                {year}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleViewData}
                            disabled={loading}
                            sx={{ width: '25%' }}
                        >
                            {loading ? 'Loading...' : 'View'}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={handleDownloadExcel}
                            sx={{ width: '25%' }}
                        >
                            Download
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    </CardContent>
</Card>

            {error && (
                <Box sx={{ mt: 2, color: 'red' }}>
                    <p>{error}</p>
                </Box>
            )}

{showTable && !loading && (
    <Box sx={{ mt: 3, width: '100%', maxWidth: '100%' }}>
        <div style={{ overflowX: 'auto', maxHeight: '600px', overflowY: 'auto' }}>
            <table border="1" cellPadding="8" cellSpacing="0" style={{ width: '100%',borderCollapse: 'collapse', tableLayout: 'auto' }}>
            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#1976d2', zIndex: 1 }}>
  <tr style={{ color: 'white' }}>
    {[
      'Branch Code', 'SCR ASC Code', 'SCR ASC Name', 'Serial No', 'SerialNo Invoice Number', 'Comp Inv Date', 'TokenNumber', 'Doc No',
      'Scr No', 'Scr Date', 'Mat Code', 'Asc Code', 'Asc Name', 'Itemdesc', 'Psg', 'Psg Descr', 'Dealer Code', 'Dealer Name', 'District Name',
      'Business Center', 'State Name', 'Doc Date', 'Cus Inv Date', 'Cus Mob', 'Cus Address', 'Dealer Based W Date', 'Cus Based W Date',
      'War Days', 'Complaint Date', 'Delivery Date', 'Def Clearence Days', 'Service Type', 'Complaint_Details', 'Spares Cost (A)',
      'GST Val. for Spares Cost(B)', 'Service Cost (C)', 'GST Val. for Service Cost (D)', 
      'App. Total Claimed Charges (W GST Val.)(A+B+C+D)', 'App. Total Claimed Charges (W/O GST Val.)(A+C)', 'Status', 'Current Approval Level',
      'Pre Scr Date', 'Scr Days Diff', 'Pre Scr Tot Claim', 'Modifiedon', 'Nof', 'Complaint Type', 'Complaint Reason', 'Complaint Category',
      'Oltips Gjv Number', 'Date'
    ].map((header, idx) => (
      <th 
        key={idx} 
        style={{
          whiteSpace: 'normal', 
          wordWrap: 'break-word', 
          maxWidth: '150px',
          overflow: 'hidden',
          textOverflow: 'ellipsis', 
          padding: '8px',
          textAlign: 'center'
        }}
      >
        {header}
      </th>
    ))}
  </tr>
</thead>

                <tbody>
                    {Array.isArray(tableData) && tableData.length > 0 ? (
                        tableData.map((row, index) => (
                            <tr key={index}>
                                <td class="text-center">{row.BRANCH_CODE}</td>
                                <td class="text-center">{row.SCR_ASC_CODE}</td>
                                <td class="text-center">{row.SCR_ASC_NAME}</td>
                                <td class="text-center">{row.SERIAL_NO}</td>
                                <td class="text-center">{row.SERIALNO_INVOICE_NUMBER}</td>
                                <td class="text-center">{row.COMP_INV_DATE}</td>
                                <td class="text-center">{row.Tokennumber}</td>
                                <td class="text-center">{row.DOC_NO}</td>
                                <td class="text-center">{row.SCR_NO}</td>
                                <td class="text-center">{row.SCR_DATE}</td>
                                <td class="text-center">{row.MAT_CODE}</td>
                                <td class="text-center">{row.ASC_CODE}</td>
                                <td class="text-center">{row.ASC_NAME}</td>
                                <td class="text-center">{row.ITEMDESC}</td>
                                <td class="text-center">{row.PSG}</td>
                                <td class="text-center">{row.PSG_DESCR}</td>
                                <td class="text-center">{row.DEALER_CODE}</td>
                                <td class="text-center">{row.DEALER_NAME}</td>
                                <td class="text-center">{row.DISTRICT_NAME}</td>
                                <td class="text-center">{row.BUSINESS_CENTER}</td>
                                <td class="text-center">{row.STATE_NAME}</td>
                                <td class="text-center">{row.DOC_DATE}</td>
                                <td class="text-center">{row.CUS_INV_DATE}</td>
                                <td class="text-center">{row.CUS_MOB}</td>
                                <td class="text-center">{row.CUS_ADDRESS}</td>
                                <td class="text-center">{row.DEALER_BASED_W_DATE}</td>
                                <td class="text-center">{row.CUS_BASED_W_DATE}</td>
                                <td class="text-center">{row.WAR_DAYS}</td>
                                <td class="text-center">{row.COMPLAINT_DATE}</td>
                                <td class="text-center">{row.DELIVERY_DATE}</td>
                                <td class="text-center">{row.DEF_CLEARANCE_DAYS}</td>
                                <td class="text-center">{row.SERVICE_TYPE}</td>
                                <td class="text-center">{row.COMPLAINT_DETAILS}</td>
                                <td class="text-center">{row['Spares Cost (A)']}</td>
                                <td class="text-center">{row['GST Val. for Spares Cost(B)']}</td>
                                <td class="text-center">{row['Service Cost (C)']}</td>
                                <td class="text-center">{row['GST Val. for Service Cost (D)']}</td>
                                <td class="text-center">{row['App. Total Claimed Charges (W GST Val.)(A+B+C+D)']}</td>
                                <td class="text-center">{row['App. Total Claimed Charges (W/O GST Val.)(A+C)']}</td>
                                <td class="text-center">{row.STATUS}</td>
                                <td class="text-center">{row.CURRENT_APPROVAL_LEVEL}</td>
                                <td class="text-center">{row.PRE_SCR_DATE}</td>
                                <td class="text-center">{row.SCR_DAYS_DIFF}</td>
                                <td class="text-center">{row.PRE_SCR_TOT_CLAIM}</td>
                                <td class="text-center">{row.modifiedon}</td>
                                <td class="text-center">{row.NOF}</td>
                                <td class="text-center">{row.COMPLAINTTYPE}</td>
                                <td class="text-center">{row.COMPLAINTREASON}</td>
                                <td class="text-center">{row.COMPLAINTCATEGORY}</td>
                                <td class="text-center">{row.OLTPS_GJV_NUMBER}</td>
                                <td class="text-center">{row.Date}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5">No data available</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    </Box>
)}

            
        </Box>
    );
};

export default Accounted_Src_Report;